/**
 * Form Progress
 *
 * For controlling the form step progress bar above the
 * vote form
 *
 */

const checkFormProgress = () => {
    const hideClassName = 'step-hidden';
    const stepLabel     = document.querySelectorAll('.form-step-label');
    const sessionKeys   = [ 'stepOneSession', 'stepTwoSession', 'stepThreeSession'];

    if( stepLabel.length > 0 ) {
        setTimeout( () => {
            for(let i = 0; i < 3; i++) {
                let   stepSessionKey = sessionKeys[i];
                const checkMark      = stepLabel[i].children[0];
                const stepNum        = stepLabel[i].children[1];
                let   sessionData    = sessionStorage.getItem(stepSessionKey)

                // Show num and make sure check mark is hidden by default
                if(stepNum.classList.contains(hideClassName)) {
                    stepNum.classList.remove(hideClassName)
                }

                if(!checkMark.classList.contains(hideClassName)) {
                    checkMark.classList.add(hideClassName)
                }

                // Check if session is set and reset the form progress
                if( sessionData ) {
                    sessionData = JSON.parse(sessionData);

                    if( sessionData.completed == true ) {
                        // If set, show check mark and make sure num label is hidden
                        if(checkMark.classList.contains(hideClassName)) {
                            checkMark.classList.remove(hideClassName)
                        }

                        if(!stepNum.classList.contains(hideClassName)) {
                            stepNum.classList.add(hideClassName)
                        }
                    }
                }
            } // for loop
        }, 750);
    }
}

checkFormProgress();
